import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import TableResults from 'views/leagues/results/tableResults'; // Importing TableResults component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for record table responses.
 * @extends JetView
 */
export default class recordTableRespontsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme from app configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from devConfig
                },
            ],
        };

        // Left side configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label for the title
                            label: _('Tabla de Resultados'), // Localized label text
                            width: 200,
                        },
                    ],
                },
                TableResults, // Including the TableResults component
                toolbar, // Adding the toolbar
            ],
        };

        // Returning the main configuration object for the view
        return {
            width: screen !== 'small' ? 400 : 230, // Conditional width based on screen size
            height: screen.width < 500 ? 500 : 0, // Conditional height based on screen width
            type: 'wide', // Type of layout
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
